/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { translate } from '@nextcloud/l10n'

export default {
	methods: {
		t: translate,
	},
}
